import { NICmsContentComponent } from '@icms/core/content';
import { NCustomerGroups } from '../../../customer/groups/customer-groups';

export namespace NPageHeader {
    export const BLOCK_ID = 'page-header';
    export const MEGANAV_GROUP_ID = 'meganav';

    export interface IBlockDataContent extends NICmsContentComponent.IData, IVersionConfig {
        logo_image: string;
        logo_alt: string;
        menu: IMenuItem[];
        promobars: IPageHeaderPromoBarData[];
        search_redirects: IRedirect[];
        wishlist_notice_added: string;
        wishlist_notice_already_on: string;
        wishlist_notice_cta_label: string;
        typeData: IVersionConfig;
    }

    export interface IMenuItem {
        // line copy
        text: string;
        // line link
        link?: string;
        // link colour
        color?: string;
        hide: boolean;
        // subcomponents
        components: NICmsContentComponent.IData[];
        visibility?: NCustomerGroups.TId | NCustomerGroups.TId[];
    }

    export interface IRedirect {
        from: string;
        to: string;
    }

    export interface IPageHeaderPromoBarData {
        turnOn: boolean;
        visibility?: NCustomerGroups.TId | NCustomerGroups.TId[];
        backgroundColor: string;
        fontColor: string;
        paddingTop: string;
        paddingBottom: string;
        paddingLeft: string;
        paddingRight: string;
        closeable: boolean;
        promobarLines: IPromoBarLine[];
        animation?: string;
        animationSpeed?: number;
        showSeparator?: boolean;
    }

    export interface IPromoBarLine {
        lineItems: IPromoBarLineItem[];
    }

    export interface IPromoBarLineItem {
        item_type: string;
        text?: string;
        link?: string;
        link_style?: string;
        end_date?: Date;
        bold: boolean;
        underline: boolean;
    }

    export interface IVersionState {
        /** Transparent background */
        transparent?: boolean;
        /** White text color */
        lightMode?: boolean;
        /** Hide up when start scrolling down */
        hideUp?: boolean;
    }

    export interface IVersionConfig {
        /** Transparent background */
        headerTransparent?: boolean;
        /** White text color */
        headerLightMode?: boolean;
        /** Hide up when start scrolling down */
        headerHideUp?: boolean;
    }

    export enum EClasses {
        transparent = 'page-header-transparent',
        lightMode = 'page-header-light-mode',
        hideUp = 'page-header-hide-up'
    }
}
